import BaseTabButtons from "@PegasusCore/pegasus-one-tab-buttons/src/script";

class TabButtons extends BaseTabButtons {
    init() {
        super.init();

        this.tabContainer = this.$el.querySelector(
            ".TabButtons__container > div"
        );
        
        setTimeout(() => {
            this.checkUrlHash();
        }, 100);
    }

    checkUrlHash() {
        const hash = window.location.hash.substring(1);
        
        if (hash && this.tabButtons.includes(hash)) {
           
            this.$nextTick(() => {
                this.activeTab = hash;
                this.scrollTabContent(hash);
                
                this.$dispatch("pegasus-tab-item-selected", {
                    targetID: hash,
                    tabGroup: JSON.stringify(this.tabButtons),
                });
            });
        }
    }

    scrollTabContent(targetID) {
        this.$dispatch("pegasus-tab-content-selected", {
            targetID: targetID,
            tabGroup: JSON.stringify(this.tabButtons),
        });
    }
}

// Wait for Alpine to be ready
document.addEventListener("alpine:init", () => {
    // Register our extended version
    Alpine.data("tabButtons", () => new TabButtons());
});

